import RESTApiEndPoints from "@/services/rest-api-end-points";
import axiosService from "@/services/axios-service";
import IMessageInfo from "@/models/mesage-info";

export default class MessageInfoService {
  public async send(message: IMessageInfo) {
    return await axiosService.post(`${RESTApiEndPoints.messageInfoUrl()}`, message);
  }
}
